module.exports = __webpack_public_path__ + "static/media/productBack5.ae6e857b.jpg";